setHomeSwiperHeight = () => {
  let trueHeight = window.innerHeight;
  let setHeight = document.querySelector("#home-swiper");
  setHeight.style.height = trueHeight + "px"; 
};

// Execute on window resize
window.addEventListener("resize", function () {
  //alert("Resize");
  setHomeSwiperHeight();
});



document.addEventListener("DOMContentLoaded", function () {
  setHomeSwiperHeight();

  let videoBlock = document.querySelector('.video');
  if(videoBlock) {
    let video = videoBlock.querySelector('video');
    //let playBtn = videoBlock.querySelector('.play-btn');
    let muteBtn = videoBlock.querySelector('.mute-btn');
  
    // playBtn.addEventListener('click', (event) => {
    //   event.preventDefault();
    //   //console.log("Pause");
    //   if (video.paused) {
    //     video.play();
    //     playBtn.textContent = 'Pause';
    //   } else {
    //     video.pause();
    //     playBtn.textContent = 'Play';
    //   }
    // });
  
    muteBtn.addEventListener('click', (event) => {
      event.preventDefault();
      //console.log("Mute");
      if (video.muted) {
        video.muted = false;
        video.volume = 0.5;
        muteBtn.querySelector('img').src = 'https://cdn.shopify.com/s/files/1/0024/3918/4502/files/sound-on.svg?v=1732044538';
        //muteBtn.textContent = 'Sound Off';
      } else {
        video.muted = true;
        muteBtn.querySelector('img').src = 'https://cdn.shopify.com/s/files/1/0024/3918/4502/files/sound-off.svg?v=1732044539';
        //muteBtn.textContent = 'Sound On';
      }
    });

    //muteBtn.click();
  }

  let verticalSwiper = document.querySelector('#home-swiper');

  if (verticalSwiper) {
    new Swiper(verticalSwiper, {
      direction: 'vertical',
      nested: true,
      effect: 'creative',
      //mousewheel: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        sensitivity: 1,
        thresholdDelta: 10
      },
      speed: 500,
      keyboard: {
        enabled: true,
      },
      creativeEffect: {
        prev: {
          translate: [0, 0, -1],
          opacity: 1
        },
        next: {
          translate: [0, "100%", 0],
          opacity: 1
        },
      },
      breakpoints: {
        500: {
          slidesPerView: 1,
        },
      },
      on: {
        slideChange: function () {
          console.log('slide changed');
        },
      },
    });
    
  }
  
  
  let homeSwipers = document.querySelectorAll('.collection-swiper');

  if (homeSwipers.length > 0) {
    homeSwipers.forEach((homeSwiper) => {
      new Swiper(homeSwiper, {
        //preloadImages: false,
        //loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        nested: true,
        //spaceBetween: 24,
        //freeMode: true,
        wrapperClass: 'collection-wrapper',
        slideClass: 'collection-slide',
        navigation: {
          nextEl: ".arrows .right",
          prevEl: ".arrows .left",
        },
        breakpoints: {
          600: {
            slidesPerView: 2,
            spaceBetween: 2
          },
          880: {
            slidesPerView: 3,
            spaceBetween: 2
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 2
          }
        },
      });
    });
  }

  // Initial execution on page load
});